import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, EmptyState, BaasicButton } from 'core/components';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';
import EmptyIcon from 'themes/assets/img/building-modern.svg';

function InsuranceOrderingListTemplate({ insuranceOrderingListViewStore }) {
    const {
        tableLoading,
        tableStore,
        authorization,
        tabItems,
        selectedStatusAbrv,
        setStatus,
        createNewInsuranceOrdering,
        getInsuranceOrderingDownloadUrl,
        uploadInsuranceOrdering,
    } = insuranceOrderingListViewStore;

    const tabButtons = tabItems ? tabItems.map(item =>
        <BaasicButton key={item.abrv}
            className={"tabs__item " + (item.abrv == selectedStatusAbrv ? 'active' : '')}
            label={item.name}
            onClick={() => item.abrv != selectedStatusAbrv ? setStatus(item.abrv) : {}}
        />
    ) : null;

    return (
        <ApplicationListLayout store={insuranceOrderingListViewStore}>
            <PageNavigation>
                <BaasicButton authorized={authorization ? authorization.create : true} className="btn btn--base btn--primary" label={'Download'} icon='u-icon u-icon--sml u-icon--download--white' onClick={() => { getInsuranceOrderingDownloadUrl() }}></BaasicButton>
                <BaasicButton authorized={authorization ? authorization.create : true} className="btn btn--base btn--primary" label={'Upload'} icon='u-icon u-icon--sml u-icon--upload--white' onClick={() => { uploadInsuranceOrdering() }}></BaasicButton>
                <BaasicButton className="btn btn--base btn--primary" label={'LIST_LAYOUT.CREATE_BUTTON'} onClick={() => createNewInsuranceOrdering()}></BaasicButton>
            </PageNavigation>

            <Content emptyRenderer={renderEmpty()} >
                <div className="tabs__wrapper is-sml">
                    <div className="tabs is-long">
                        {tabButtons}
                    </div>
                </div>

                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='DIAGNOSIS_CODE.LIST.EMPTY_STATE.TITLE' description='DIAGNOSIS_CODE.LIST.EMPTY_STATE.DESCRIPTION' />
}

InsuranceOrderingListTemplate.propTypes = {
    insuranceOrderingListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(InsuranceOrderingListTemplate);